export const CopyIcon = ({ color = 'black' }) => (
  <svg width='17' height='20' viewBox='0 0 17 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.73682 3.84211V3C5.73682 1.89543 6.63225 1 7.73682 1H14.1579C15.2624 1 16.1579 1.89543 16.1579 3V12.2632C16.1579 13.3677 15.2624 14.2632 14.1579 14.2632H13.7894'
      stroke={color}
    />
    <rect x='1' y='5.73828' width='10.4211' height='13.2632' rx='2' stroke={color} />
  </svg>
)
